import React from "react";
import SEO from "../components/SEO";
import { Shield, Sparkles, Globe2 } from "lucide-react";

const About = () => (
  <div className="relative min-h-screen bg-[#0B0F19] text-white">
    <SEO title="About Us - QryptShield" />
    <div className="absolute inset-0 z-0 pointer-events-none">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[950px] h-[480px] bg-blue-600/20 rounded-[100%] blur-[120px]" />
    </div>

    <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-12">
      <div className="text-center space-y-4 mt-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-semibold">
          <Sparkles className="w-4 h-4" /> Welcome to QryptShield
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">
          Quantum-Ready Security
        </h1>
        <p className="text-gray-400 max-w-3xl mx-auto">
          An IIT Kanpur based startup powered by expertise, validated by
          research.
        </p>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 shadow-xl space-y-4">
        <p className="text-sm uppercase tracking-[0.25em] text-blue-300">
          QRYPTSHIELD
        </p>
        <h2 className="text-2xl font-semibold text-white">Why we exist</h2>
        <p className="text-gray-300 leading-relaxed">
          QryptShield is solving the risk that quantum computers will break
          today&apos;s security systems like RSA and ECC, exposing sensitive
          data of enterprises, governments, and critical infrastructure. To
          prevent this, we build easy-to-use Post-Quantum Cryptography (PQC)
          solutions such as secure browsers, VPNs, chat apps, and migration
          tools.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 shadow-xl space-y-3">
          <div className="flex items-center gap-2 text-blue-300 font-semibold text-xs uppercase tracking-widest">
            <Shield className="w-4 h-4" /> Our Mission
          </div>
          <p className="text-gray-300 leading-relaxed">
            To deliver innovative and tailored solutions to the global defence
            industry, enabling organizations to meet evolving challenges through
            advanced technologies, localized manufacturing, and strategic
            partnerships.
          </p>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 shadow-xl space-y-3">
          <div className="flex items-center gap-2 text-blue-300 font-semibold text-xs uppercase tracking-widest">
            <Globe2 className="w-4 h-4" /> Our Vision
          </div>
          <p className="text-gray-300 leading-relaxed">
            Innovation and Excellence. To be the leading provider of
            quantum-resistant security solutions, ensuring digital
            infrastructure is prepared for tomorrow&apos;s quantum computing
            threats while maintaining the highest standards of security and
            reliability.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default About;
